import React, { useState, useEffect } from "react";
import "./MathLadder.css";

export default function MathLadder() {
  const [mode, setMode] = useState("easy");
  const [level, setLevel] = useState(0);
  const [question, setQuestion] = useState({});
  const [answer, setAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [message, setMessage] = useState("");

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  useEffect(() => {
    resetGame();
  }, [mode]);

  useEffect(() => {
    let timer;
    if (!gameOver) {
      timer = setInterval(() => setTime((t) => t + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [gameOver]);

  const resetGame = () => {
    generateQuestion();
    setScore(0);
    setTime(0);
    setLevel(0);
    setGameOver(false);
    setMessage("");
  };

  const generateQuestion = () => {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    let op;

    if (mode === "easy") {
      op = ["+", "-"][Math.floor(Math.random() * 2)];
    } else {
      op = ["+", "-", "*", "/"][Math.floor(Math.random() * 4)];
    }

    setQuestion({ a, b, op });
  };

  const checkAnswer = () => {
    let correct;
    switch (question.op) {
      case "+": correct = question.a + question.b; break;
      case "-": correct = question.a - question.b; break;
      case "*": correct = question.a * question.b; break;
      case "/": correct = Math.floor(question.a / question.b); break;
      default: correct = 0;
    }

    if (parseInt(answer) === correct) {
      setLevel(level + 1);
      setScore(score + 10);
      setMessage("✅ Correct! Climb up!");
      correctSound.play();
      if (level + 1 === 10) {
        setMessage("🎉 You reached the top! Final Score: " + (score + 10));
        setGameOver(true);
        winSound.play();
      } else {
        generateQuestion();
      }
    } else {
      setLevel(Math.max(level - 1, 0));
      setScore(score - 5);
      setMessage("❌ Wrong! Try again.");
      wrongSound.play();
    }
    setAnswer("");
  };

  return (
    <div className="ladder-container">
      <h1>🪜 Math Ladder</h1>
      <div className="mode-buttons">
        <button onClick={() => setMode("easy")}>Under 12</button>
        <button onClick={() => setMode("hard")}>Above 12</button>
      </div>
      <div className="stats">
        <p>⏱ Time: {time}s</p>
        <p>⭐ Score: {score}</p>
        <p>📍 Level: {level}</p>
      </div>
      {!gameOver && (
        <div className="question-box">
          <p>Solve: {question.a} {question.op} {question.b} = ?</p>
          <input
            type="number"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="answer-input"
          />
          <button onClick={checkAnswer}>Submit</button>
        </div>
      )}

     <div className="ladder-visual">
  {[...Array(10)].map((_, i) => (
    <div key={i} className="rung">
      {i === level && (
        <div className="player-icon">
          🧍
        </div>
      )}
    </div>
  ))}
</div>




      <p className="status">{message}</p>
    </div>
  );
}